import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getSessionId() {
  try {
    return localStorage.getItem("psf_session_id") || "";
  } catch {
    return "";
  }
}

export function trackEvent(type, payload = {}) {
  // Fire-and-forget — never blocks the UI, swallows errors
  axios
    .post(`${API}/events`, {
      type,
      session_id: getSessionId(),
      payload,
    })
    .catch(() => {});
}
